import React from "react";
import LegalMarkdownPage from "./LegalMarkdownPage";

import legalNoticeEnglish from "../docs/legal/legal-notice/legal.en.md"; //
import legalNoticeFrench from "../docs/legal/legal-notice/legal.en.md";
import legalNoticeArabic from "../docs/legal/legal-notice/legal.en.md";
import legalNoticeSpanish from "../docs/legal/legal-notice/legal.en.md";
import legalNoticeItalian from "../docs/legal/legal-notice/legal.en.md";

import "../styles/LegalPages.css";

const legalNoticeDocuments = {
  en: legalNoticeEnglish,
  fr: legalNoticeFrench,
  ar: legalNoticeArabic,
  es: legalNoticeSpanish,
  it: legalNoticeItalian,
};

const LegalNotice = () => {
  return (
    <LegalMarkdownPage
      documents={legalNoticeDocuments}
      containerClassName="legal-page-container"
      headingClassName="legal-page-heading"
      errorMessage="The Legal Notice could not be loaded."
    />
  );
};

export default LegalNotice;
